export const reduxKey = '@@TAG_INPUT';

//# sourceMappingURL=constants.js.map